import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {

  constructor( public loginService: LoginService) { }

    public message;
    public msg;
    // public behaviour;

  ngOnInit(): void {
    this.loginService.dataSource.subscribe(data=>{
      
    let collect=JSON.parse(localStorage.getItem('loginUser')).userName
      this.msg = data;
      console.log(data)
      this.msg.forEach(
        function(each){
          if(each.sender==collect){
            each.check=true
            console.log(true)
          }
          else{
            each.check=false
          }
          }
      )
    })
  }
  
  sendMessage(){
    let current=JSON.parse(localStorage.getItem('loginUser')).userName
    let reci=JSON.parse(localStorage.getItem('receiver')).userName

    let d = new Date();
    let n = d.toLocaleTimeString();

    // let time=`${new Date().getHours()} : ${new Date().getMinutes()}`
    let obj={sender:current, receiver:reci, text:this.message, n}
    this.msg.push(obj)
    let tmes
        if(localStorage.getItem('messages')){
          tmes=JSON.parse(localStorage.getItem('messages'))
        }
        else{
          tmes=[]
        }
          tmes.push(obj)
          localStorage.setItem('messages',JSON.stringify(tmes))
          this.loginService.updateSource(this.msg);
          this.message="";
        }
}
